import api from "@/config/axiosConfig";
import { Trip, TripX } from "@/types/trip";

interface GetTripsParams {
  todos?: boolean;
  currency?: string;
}

interface CreateTripParams {
  name: string;
  privacy_status?: "private" | "public";
}

interface UpdateTripParams {
  name?: string;
  privacy_status?: "private" | "public";
  images?: string[];
}

class TripService {
  async getTrips(params?: GetTripsParams): Promise<TripX[]> {
    const response = await api.trips.get("", { params });
    return response.data;
  }

  async getTrip(tripId: string, params?: GetTripsParams): Promise<Trip> {
    const response = await api.trips.get(`${tripId}`, { params });
    return response.data;
  }

  async createTrip(data: CreateTripParams): Promise<Trip> {
    const response = await api.trips.post(".", data);
    return response.data;
  }

  async updateTrip(tripId: string, data: UpdateTripParams): Promise<Trip> {
    const response = await api.trips.patch(tripId, data);
    return response.data;
  }

  async deleteTrip(tripId: string): Promise<void> {
    await api.trips.delete(tripId);
  }

  // Additional methods for other trip-related operations can be added here
  async addParticipant(tripId: string, userId: string): Promise<void> {
    await api.trips.post(`${tripId}/participants`, { user_id: userId });
  }

  async removeParticipant(tripId: string, userId: string): Promise<void> {
    await api.trips.delete(`${tripId}/participants/${userId}`);
  }

  async updateParticipantRole(
    tripId: string,
    userId: string,
    isAdmin: boolean
  ): Promise<void> {
    await api.trips.patch(`${tripId}/participants/${userId}`, {
      is_admin: isAdmin,
    });
  }

  async addTripUsers(
    tripId: string,
    userIds: string[]
  ): Promise<{
    success: boolean;
    message: string;
    users:
      | {
          user_id: string;
          first_name: string;
          last_name: string;
          username: string;
          profile_image: string;
          is_admin: boolean;
        }[]
      | null;
  }> {
    const response = await api.social.post("/trips/participants", {
      trip_id: tripId,
      user_ids: userIds,
    });
    return response.data;
  }
}

export const tripService = new TripService();
export default tripService;
